<template>
  <div id="container">
    <ChpContentDesktop @back="backhome" v-if="parIndex>0" :part="parIndex" :chapter="chpIndex" :section="secIndex" :fig="figIndex" :alias="clickAlias"></ChpContentDesktop>
    <div v-show="parIndex==0" id="homeBackground" :style="{width:width,height:height}">
      <img :src="bgUrl" alt="" id='bg-home'>
    </div>
    <div v-show="parIndex==0" id="homePage" :style="{width:width}">
      <div id = 'content'>
        <div id = 'startDIV'>
          <img :src="titleUrl" alt="" id='title'>
          <div id="intro">
            <p style="font-weight:700;margin-bottom:5px;color:#fff">2018 BCS John Bartholomew Award & Stanford Award | Judges’ comments</p>
            <p>“Very clever and visually attractive presentation of huge amount of complex information. Great collection of inventive, beautifully designed thematic maps and infographics. Very engaging and beautiful to look at, with good mixture of styles of thematic maps and infographics. Very well focused on the theme and the wide range of topics is dealt with imaginatively. A great achievement, containing fine examples of thematic cartography. ”
“Artistically stunning and packed with imaginative cartographic presentation. Magnificent. ”
</p>
          </div>
        </div>
        <div id="middleDIV">
          <div id="contentsLink">
            <div class="par-box" id="parBox1" @mouseenter="showChapterContents" @mouseleave="closeChapterContents">
              <div class="par">
                <div class="par-num pageColor1" id="parNum1"></div>
                <div class="par-name" id="parName1" @click="parSwitch">
                  <p class="par-name-cn" id="parNameCN1">文前</p>
                  <p class="par-name-en" id="parNameEN1">Before Reading</p>
                </div>
              </div>
              <div class="chp-box" id="chpBox1">
                <div class="chp_" id="par1-chps"></div>
              </div>
            </div>
            <div class="par-box" id="parBox2" @mouseenter="showChapterContents" @mouseleave="closeChapterContents">
              <div class="par">
                <div class="par-num pageColor2" id="parNum2">Ⅰ</div>
                <div class="par-name" id="parName2" @click="parSwitch">
                  <p class="par-name-cn" id="parNameCN2">热带气旋的发生、发展和消亡</p>
                  <p class="par-name-en" id="parNameEN2">Genesis, Development and Dissipation of Tropical Cyclones</p>
                </div>
              </div>
              <div class="chp-box" id="chpBox2">
                <div class="chp_" id="par2-chps"></div>
              </div>
            </div>
            <div class="par-box" id="parBox3" @mouseenter="showChapterContents" @mouseleave="closeChapterContents">
              <div class="par">
                <div class="par-num pageColor3" id="parNum3">Ⅱ</div>
                <div class="par-name" id="parName3" @click="parSwitch">
                  <p class="par-name-cn" id="parNameCN3">热带气旋的路径和移动</p>
                  <p class="par-name-en" id="parNameEN3">Tracks and Propagation of Tropical Cyclones</p>
                </div>
              </div>
              <div class="chp-box" id="chpBox3">
                <div class="chp_" id="par3-chps"></div>
              </div>
            </div>
            <div class="par-box" id="parBox4" @mouseenter="showChapterContents" @mouseleave="closeChapterContents">
              <div class="par">
                <div class="par-num pageColor4" id="parNum4">Ⅲ</div>
                <div class="par-name" id="parName4" @click="parSwitch">
                  <p class="par-name-cn" id="parNameCN4">影响和登陆中国的热带气旋</p>
                  <p class="par-name-en" id="parNameEN4">Tropical Cyclones Affecting and Landfalling in China</p>
                </div>
              </div>
              <div class="chp-box" id="chpBox4">
                <div class="chp_" id="par4-chps"></div>
              </div>
            </div>
            <div class="par-box" id="parBox5" @mouseenter="showChapterContents" @mouseleave="closeChapterContents">
              <div class="par">
                <div class="par-num pageColor5" id="parNum5">Ⅳ</div>
                <div class="par-name" id="parName5" @click="parSwitch">
                  <p class="par-name-cn" id="parNameCN5">热带气旋统计表</p>
                  <p class="par-name-en" id="parNameEN5">Lists of Tropical Cyclones</p>
                </div>
              </div>
              <div class="chp-box" id="chpBox5">
                <div class="chp_" id="par5-chps"></div>
              </div>
            </div>
            <div class="par-box" id="parBox6" @mouseenter="showChapterContents" @mouseleave="closeChapterContents">
              <div class="par">
                <div class="par-num pageColor6" id="parNum6"></div>
                <div class="par-name" id="parName6" @click="parSwitch">
                  <p class="par-name-cn" id="parNameCN6">附录</p>
                  <p class="par-name-en" id="parNameEN6">Appendixes</p>
                </div>
              </div>
              <div class="chp-box" id="chpBox6">
                <div class="chp_" id="par6-chps"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable eqeqeq */
// @ is an alias to /src
import { contents, reverseIndex } from '../assets/contents'
import ChpContentDesktop from '@/components/ChpContentDesktop.vue'

export default {
  data: function () {
    return {
      parIndex: 0,
      chpIndex: 1,
      secIndex: 0,
      figIndex: 1,
      pageHeight: document.documentElement.clientHeight,
      pageWidth: document.documentElement.clientWidth,
      height: '',
      width: '',
      isMobile: false,
      bgUrl: require('../../public/home-background.png'),
      titleUrl: require('../../public/title.png'),
      clickAlias: '',
      firstShow: 0
    }
  },
  components: {
    ChpContentDesktop
  },
  methods: {
    parSwitch: function (e) {
      const that = this
      var getItem = e.target.id
      that.clickAlias = 'par'
      var v = getItem.split('')
      v = v[v.length - 1]
      that.parIndex = parseInt(v)
      that.figIndex = contents[that.parIndex - 1].parIndex[3]
    },
    chpSwitch: function (event, e) {
      const that = this
      var getItem = e.getAttribute('id')
      that.clickAlias = 'chp'
      var v = getItem.replace('chp', '')
      that.chpIndex = parseInt(v)
      that.parIndex = reverseIndex.chppar[that.chpIndex - 1]
      that.figIndex = contents[that.parIndex - 1].chapter[parseInt(v) - reverseIndex.parchp[that.parIndex - 1]].chpIndex[3]
    },
    secSwitch: function (event, e) {
      const that = this
      var getItem = e.getAttribute('id')
      that.clickAlias = 'sec'
      var v = getItem.replace('sec', '')
      that.secIndex = parseInt(v)
      that.parIndex = reverseIndex.secpar[that.secIndex - 1]
      that.chpIndex = reverseIndex.secchp[that.secIndex - 1]
      that.figIndex = contents[that.parIndex - 1].chapter[that.chpIndex - reverseIndex.parchp[that.parIndex - 1]].section[parseInt(v) - reverseIndex.chpsec[that.chpIndex - 1]].secIndex[3]
    },
    showChapterContents: function (e) {
      var getEle = e.target.id.split('')
      document.getElementById(`chpBox${getEle[getEle.length - 1]}`).style.display = 'block'
      document.getElementById(`parName${getEle[getEle.length - 1]}`).style.backgroundColor = 'rgba(255, 255, 255, 0.5)'
    },
    closeChapterContents: function (e) {
      var getEle = e.target.id.split('')
      document.getElementById(`chpBox${getEle[getEle.length - 1]}`).style.display = 'none'
      document.getElementById(`parName${getEle[getEle.length - 1]}`).style.backgroundColor = 'rgba(255, 255, 255, 0.8)'
    },
    backhome: function () {
      const that = this
      that.parIndex = 0
      that.chpIndex = 1
      that.secIndex = 0
      that.figIndex = 1
    },
    ifFirstTouch: function () {
      const that = this
      that.firstShow = 1
    }
  },
  created () {
    const that = this
    window.chpSwitch = that.chpSwitch// 这是html的onclick方法，不是vue的v-on:click
    window.secSwitch = that.secSwitch// 函数挂载到window上，这样你动态创建html元素的时候，它才知道你绑定的函数是什么
    that.width = that.pageWidth + 'px'
    that.height = that.pageHeight + 'px'
    if (that.pageWidth < 980) {
      that.width = '980px'
      document.body.style.overflowX = 'auto'
    }
  },
  mounted () {
    const that = this
    that.chpIndex = 0
    that.toolIndex = 0
    that.videoIndex = 0
    // dom生成目录
    for (var p = 1; p <= 6; p++) {
      var par = p
      var parDOM = document.getElementById(`par${par}-chps`)
      var parhtml = ''
      const par1chps = contents[par - 1].chapter
      for (var i = 0; i < par1chps.length; i++) {
        var chpNum = par1chps[i].chpIndex[1]
        var chpName = par1chps[i].name
        var chpNameEN = par1chps[i].nameEN
        var chpNumStr = chpNum + ''
        var chphtml = `<div class= 'chp-container' id='par-chp${chpNum}'>
                    <div onclick="chpSwitch(event, this)" class = 'chpEnter hoverText' id = 'chp${chpNum}'>
                    <div class=" chpNamePart hoverText">
                    <div class='chpSymbol' id='symbol-chp${chpNum}'>${chpNumStr}</div>
                    <p class='chpNameCN'>${chpName}</p></div>
                  <p class='chpNameEN'>${chpNameEN}</p></div>
                  <div class='chpLine' id='line-chp${chpNum}'></div>
                  <div class='sec-container' id = 'chp-secs${chpNum}'>`
        var chpSecs = par1chps[i].section
        var sechtml = ''
        for (var j = 0; j < chpSecs.length; j++) {
          var secNum = chpSecs[j].secIndex[2]
          var secName = chpSecs[j].name
          var secNameEN = chpSecs[j].nameEN
          sechtml = sechtml + `<div onclick="secSwitch(event, this)" class='secEnter hoverText' id ='sec${secNum}'>
                            <p class='secNameCN'>${secName}</p>
                            <p class='secNameEN'>${secNameEN}</p>
                          </div>`
        }
        parhtml = parhtml + chphtml + sechtml + '</div></div>'
      }
      parDOM.innerHTML = parhtml
    }
    window.addEventListener('resize', function () {
      const h = document.documentElement.clientHeight
      const w = document.documentElement.clientWidth
      that.width = w + 'px'
      that.height = h + 'px'
      if (w < 980) {
        that.width = '980px'
        document.body.style.overflowX = 'auto'
      }
    })
  }
}
</script>
<style>
#container{
  background-color: #1F4263;
  position: relative;
}
#homeBackground{
  position: fixed;
  left: 0;
  top: 0;
  z-index: 0;
  text-align: center;
  background-color: #1F4263;
}
#bg-home{
  width: 100%;
  margin-top: -50px;
  opacity:0.2
}
#homePage{
  z-index: 20;
  height:100%;
  overflow-y: auto;
}
#content{
  width: 100%;

  position: relative;
}
#startDIV{
  width: 80%;
  margin: 0 auto;
  text-align: center;
  overflow-x: hidden;
}
#title{
  margin-top: 30px;
  width: 800px;
}
#intro{
  width: 800px;
  margin: 0 auto;
  margin-top: 60px;
  line-height: 22pt;
  font-size: 14pt;
  font-weight: 100;
  font-family: "Times New Roman",Georgia,Serif;
  min-width: 800px;
  color: #adc5db;
}
#middleDIV{
  width: 80%;
  margin: 0 auto;
  margin-top: 100px;
  overflow-x: hidden;
  min-width: 800px;
}
.par-box{
  width: 800px;
  margin: 40px auto;
}
.par{
  height: 80px;
  display:flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: stretch;
}
.par-num{
  height: 80px;
  width: 80px;
  color: rgb(231, 231, 231);
  font-size: 40px;
  text-align: center;
  line-height: 80px;
  font-family: "Times New Roman",Georgia,Serif;
}
.par-name{
  height: 80px;
  width: 700px;
  background-color: rgba(255, 255, 255, 0.8);
  color: rgb(31, 31, 31);
  display: flex;
  justify-content: center;
  flex-direction: column;
  line-height: 1.5em;
  cursor: pointer;
}
.par-name-cn{
  margin: 5px 20px;
  font-size: 30px;
}
.par-name-en{
  margin: 0 20px;
  font-size: 16px;
  line-height: 16px;
}
.chp-box{
  width: 800px;
  margin-top: 10px;
  background-color: rgba(255, 255, 255, 0.5);
  display: none;
}
.chp_{
  padding: 30px 80px;
}
.chp-container{
  color: rgb(33, 49, 66);
  font-size:16pt;
  font-weight: 700px;
  width:auto;
  height:auto;
  margin-left:20px;
  margin-top:20px;
}
.hoverText:hover{
  color: rgb(255, 255, 255);
  cursor: pointer;
}
.chpNamePart{
  display:flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  font-weight: 600;
}
.chpNameEN{
  height: 16px;
  line-height: 16px;
  font-size: 10pt;
  margin-bottom: 5px;
}
.chpLine{
  height: 1px;
  width: 620px;
  background-color: rgb(70, 70, 70);
  margin-bottom: 12px;
}
.chpSymbol{
  height:21px;
  width:21px;
  background-color: rgb(0, 0, 0);
  color:white;
  line-height: 21px;
  text-align: center;
  font-weight:700;
  font-size: 12pt;
  margin-right: 12px;
}
.sec-container{
  margin-left: 50px;
  width: 500px;
}
.secEnter{
  line-height: 1.2em;
  font-size: 12pt;
  font-weight: 600;
  display:flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
  margin-bottom: 15px;
}
.secNameEN{
  font-size: 10pt;
  line-height: 1.05em;
}
</style>
